<template>
  <el-row>
    <el-col :span="12">
      <el-form-item label="同步更新接口	" prop="putApi">
        <el-input v-model.trim="value.putApi" size="small" />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="同步更新参数" prop="putParas">
        <el-input v-model.trim="value.putParas" size="small" />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="默认值抽取接口" prop="getApi">
        <el-select v-model="value.getApi" size="small" @change="resetGetRes" filterable clearable style="width: 93%">
          <el-option v-for="item in mrApiList" :key="item.id" :label="item.name" :value="item.code" />
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="默认值抽取结果" prop="getRes">
        <el-cascader v-if="getRes && getRes.length" v-model="getRes" :options="resOptions" @change="changeGetRes" :props="utils.eleTreeProp" :key="optionsKey" separator=" - " style="width: 93%" size="small"></el-cascader>
      </el-form-item>
    </el-col>
    <!-- <el-col :span="12">

      <el-form-item label="默认值抽取参数	" prop="getParas">
        <el-input v-model.trim="value.getParas" size="small" />
      </el-form-item>
    </el-col> -->
  </el-row>
</template>

<script>
  import editorUtils from "@/common/editorUtils";

  export default {
    props: {
      value: Object,
    },
    data() {
      return {
        mrApiList: [],
        getRes: [],
        optionsKey: 0,
        utils: editorUtils,
      };
    },
    computed: {
      selectedGetApi() {
        return this.mrApiList.find((item) => item.code === this.value.getApi);
      },
      resOptions() {
        let str = this.selectedGetApi?.struct;
        if (str) {
          return [JSON.parse(str)];
        } else {
          return null;
        }
      },
    },
    watch: {
      value() {
        this.init();
      },
    },
    created() {
      this.getMrApiList();
      this.init();
    },
    methods: {
      init() {
        if (this.value.getRes) {
          this.getRes = this.value.getRes.split(".");
        }
      },
      getMrApiList() {
        this.$api.Api.query().then((res) => {
          this.mrApiList = res.items;
        });
      },
      resetGetRes() {
        ++this.optionsKey;
        console.log(this.selectedGetApi);
        this.getRes = null;
        this.value.getRes = null;
      },
      changeGetRes() {
        if (this.getRes && this.getRes.length) {
          this.value.getRes = this.getRes.join(".");
        } else {
          this.value.getRes = null;
        }
      },
      getChildren(obj) {
        let children = [];
        Object.keys(obj).forEach((k) => {
          obj[k];
        });
      },
    },
  };
</script>
